import { render, staticRenderFns } from "./ProtocolMediaGallery.vue?vue&type=template&id=6b78d990&scoped=true"
import script from "./ProtocolMediaGallery.vue?vue&type=script&lang=js"
export * from "./ProtocolMediaGallery.vue?vue&type=script&lang=js"
import style0 from "./ProtocolMediaGallery.vue?vue&type=style&index=0&id=6b78d990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b78d990",
  null
  
)

export default component.exports